import { render, staticRenderFns } from "./PatternForm.vue?vue&type=template&id=c0be5c5e&scoped=true"
import script from "./PatternForm.vue?vue&type=script&lang=js"
export * from "./PatternForm.vue?vue&type=script&lang=js"
import style0 from "./PatternForm.vue?vue&type=style&index=0&id=c0be5c5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0be5c5e",
  null
  
)

export default component.exports